import { createStore, sample } from 'effector'
import { SteamUserDataType } from '@/entities/user'
import { useSteamDataResponse } from '@/entities/user'
import { goOnPrivateError } from '@/app/routing/events'
import { getUserProfileFx } from '@/entities/user'
import { getRecommendationsFx, getSteamRefreshFx } from './effects'
import { FavoriteGame } from './types/types'

export const $steamUserData = createStore<SteamUserDataType | null>(null)
  // .on(getUserProfileFx.doneData, (_, data) => useSteamDataResponse(data))
  .on(getUserProfileFx.doneData, (_, data) => {
    if (data.steam_data == null && data.user.steam_update_in_progress === false) {
      sample({
        clock: $steamUserData,
        filter: (steamData) => steamData === null,
        target: goOnPrivateError,
      })
    }
    return useSteamDataResponse(data)
  })

export const $isSteamDataLoading = createStore<boolean>(false)
  .on(getUserProfileFx.doneData, (_, data) => {
    if (data.steam_data) {
      if (data.user.steam_update_in_progress === true || data.steam_data.scoring_diff === null) {
        return true
      } else {
        return false
      }
    }
    return false
  })
  .on(getUserProfileFx.pending, (_, pending) => pending)

export const $refreshStatus = createStore<boolean>(true).on(getSteamRefreshFx.doneData, (_, data) => data.ok)

export const $favoriteGames = createStore<FavoriteGame[] | null>(null).on(
  getRecommendationsFx.doneData,
  (_, data) => data.recommended_games
)
